goog.provide("shadow.js.shim.module$$mui$material$Tabs");
goog.provide("module$shadow_js_shim_module$$mui$material$Tabs");
shadow.js.shim.module$$mui$material$Tabs = shadow.js.nativeProvides["@mui/material/Tabs"] = shadow$bridge("@mui/material/Tabs");
module$shadow_js_shim_module$$mui$material$Tabs.default = shadow.js.shim.module$$mui$material$Tabs;
